import type { LandingCopy } from './copy';

/** Native <details>: an accordion with no script, and Ctrl+F still finds a closed answer. */
export const Faq = ({ copy }: { copy: LandingCopy['faq'] }) => (
  <section id="faq" className="lp-section lp-section--alt">
    <div className="lp-container">
      <h2>{copy.title}</h2>
      <p className="lp-section__intro">{copy.intro}</p>
      <div className="lp-faq">
        {copy.items.map((item) => (
          <details key={item.q}>
            <summary>{item.q}</summary>
            <p>{item.a}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
);
